export default function AppDownload() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1000px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
                香香漫画 APP 下载
              </h2>
              <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-6">
                下载香香漫画APP，享受更流畅的香香漫画免费下拉阅读体验。支持离线缓存、书架同步、个性化推荐等专属功能，随时随地畅享好看的漫画免费全集。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-apple-fill text-2xl text-foreground-900"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-500">Download on the</div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">App Store</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-google-play-fill text-2xl text-foreground-900"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-500">GET IT ON</div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">Google Play</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50/15 border border-background-50/30 rounded-xl cursor-pointer hover:bg-background-50/25 transition-colors">
                  <i className="ri-android-line text-2xl text-background-50"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-background-50/70">安卓直接下载</div>
                    <div className="text-sm font-semibold text-background-50 whitespace-nowrap">APK 安装包</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20smartphone%20mockup%20showing%20a%20manga%20reading%20app%20interface%20with%20colorful%20illustration%20on%20screen%2C%20warm%20coral%20and%20amber%20tones%2C%20clean%20modern%20UI%20design%2C%20soft%20natural%20lighting%20on%20the%20device%2C%20minimal%20background%20with%20gentle%20gradients%2C%20editorial%20product%20photography%20style%2C%20high%20detail%2C%20professional%20composition&width=500&height=700&seq=app-manga-01&orientation=portrait"
                alt="香香漫画 - APP下载手机界面展示"
                className="w-full max-w-[200px] md:max-w-[240px] rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}